/* eslint-disable */
import React, { useCallback, useEffect, useState } from "react";
import { Input, Button, Text } from "../components";
import { useAxios, useRouter } from "../hooks";
import { responseChecker } from "../utils";
import { checkPass } from "../api";
import style from "./Views.module.css";

const initialState = {
  pass: "",
  text: "",
  load: false,
};
export default function GetVideo() {
  const [state, setState] = useState(initialState);
  const router = useRouter();
  const id = router.query.id;

  const { response, loading } = useAxios({
    method: "get",
    url: `/check/${id}`,
  });

  useEffect(() => {
    if (!!response) {
      if (response.has_link) return responseChecker("LINK", response, id);
      if (response.has_video) return responseChecker("VIDEO", response, id);
      if (response.error) return null;
      if (!response.has_video && typeof response.has_link === "undefined")
        return responseChecker("EMPTY", null, id);
    }
  }, [response, id]);

  const handleState = (name, value) => {
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const callApi = async () => {
    setState((prevState) => ({
      ...prevState,
      text: "",
      load: true,
    }));
    const res = await checkPass(id, state.pass);
    if (!!res) {
      if (res.has_link) return responseChecker("LINK", res, id);
      if (res.has_video) return responseChecker("VIDEO", res, id);
      if (res.error === "Invalid passcode") {
        setState((prevState) => ({
          ...prevState,
          text: "رمز ورود اشتباه است!",
          load: false,
        }));
        return null;
      }
      if (!res.has_video && typeof res.has_link === "undefined")
        return responseChecker("EMPTY", null, id);
    }
  };

  const changeInput = useCallback((e) => {
    handleState("pass", e.target.value);
  }, []);

  const Content = response?.error === "password required" && (
    <>
      <Input password={state.pass} handlePasswordChange={changeInput} />
      <Button onClick={callApi} loading={state.load} />
      <Text text={state.text} />
    </>
  );

  return (
    <div className={style.container}>
      <div className={style.oroGalley}>Oro Gallery</div>
      {!loading && Content}
    </div>
  );
}
